import { UseMutationOptions } from '@tanstack/react-query';

import { RequestData } from '@/api/rest/hooks/types';
import { useApiDeleteRequest } from '@/api/rest/hooks/useApiDeleteRequest';
import { useApiPatchRequest } from '@/api/rest/hooks/useApiPatchRequest';
import { useApiPostRequest } from '@/api/rest/hooks/useApiPostRequest';

import {
  DELETE_WORKSTREAM_PATH,
  DeleteWorkstreamErrorDto,
  DeleteWorkstreamRequestPathVariables,
  DeleteWorkstreamRequestQueryParams,
  DeleteWorkstreamSuccessDto,
  PATCH_WORKSTREAM_PATH,
  PatchWorkstreamErrorDto,
  PatchWorkstreamRequestBodyData,
  PatchWorkstreamRequestPathVariables,
  PatchWorkstreamRequestQueryParams,
  PatchWorkstreamSuccessDto,
  POST_WORKSTREAM_PATH,
  PostWorkstreamErrorDto,
  PostWorkstreamRequestBodyData,
  PostWorkstreamRequestPathVariables,
  PostWorkstreamRequestQueryParams,
  PostWorkstreamSuccessDto,
} from './types/workstreams';

export const usePostWorkstream = () => {
  return useApiPostRequest<
    PostWorkstreamRequestPathVariables,
    PostWorkstreamRequestQueryParams,
    PostWorkstreamRequestBodyData,
    PostWorkstreamSuccessDto,
    PostWorkstreamErrorDto
  >(POST_WORKSTREAM_PATH);
};

export const usePatchWorkstream = (
  options?: Omit<
    UseMutationOptions<
      PatchWorkstreamSuccessDto,
      PatchWorkstreamErrorDto,
      RequestData<
        PatchWorkstreamRequestPathVariables,
        PatchWorkstreamRequestQueryParams,
        PatchWorkstreamRequestBodyData
      >
    >,
    'mutationFn'
  >,
) => {
  return useApiPatchRequest<
    PatchWorkstreamRequestPathVariables,
    PatchWorkstreamRequestQueryParams,
    PatchWorkstreamRequestBodyData,
    PatchWorkstreamSuccessDto,
    PatchWorkstreamErrorDto
  >(PATCH_WORKSTREAM_PATH, options);
};

export const useDeleteWorkstream = () => {
  return useApiDeleteRequest<
    DeleteWorkstreamRequestPathVariables,
    DeleteWorkstreamRequestQueryParams,
    DeleteWorkstreamSuccessDto,
    DeleteWorkstreamErrorDto
  >(DELETE_WORKSTREAM_PATH);
};
